import {getConfiguration} from '@/services/apiService.js'
import { mergeObjects } from '@/libs/utils.js'

export const defaults = {
  extranetBar: {
    url: "https://cdn.digitalpa.it/extranet-header/v2.0/extranet-header/extranet-header.esm.js",
    configuration: {},
  },
  routes: [
    { name: 'Dashboard', component: "Dashboard", type: 'page', meta: {title: "Dashboard"} },
    { name: 'Permissions', path: '/:type/permissions/:id', folder: 'Generics', component: "Permissions", type: 'permissions', meta: {title: "Permessi", sidebar: false}},
    { name: 'CompiledPoll', folder: 'CompiledPoll', component: "CompiledPoll", type: 'crud', meta: {title: "CompiledPoll"} },
    { name: 'Campaign', folder: 'Campaign', component: "Campaign", type: 'crud', meta: {title: "Campaign", canEdit: true} },
    { name: 'CMB_CompiledPoll', folder: 'CMB', component: "CMB_CompiledPoll", type: 'crud', meta: {title: "CMB CompiledPoll"}},
    { name: 'CMB_CompiledPollEditProperty', path: '/CMB_CompiledPollEditProperty/:id/edit-property', folder: 'CMB', component: 'CMB_CompiledPollEditProperty', type: 'page', meta: {title: "CMB Edit Property CompiledPoll", sidebar: false}},
    { name: 'CMB_Permissions', path: '/:type/permissions/:id', folder: 'CMB', component: "CMB_Permissions", type: 'permissions', meta: {title: "Permessi CMB", sidebar: false}},
    { name: 'CMB_Campaign', folder: 'CMB', component: 'CMB_Campaign', type: 'crud', meta: {title: "CMB Campaign", canEdit: true}},
    { name: 'CMB_CampaignSummary', path: '/campaign/summary/:cId', folder: 'CMB', component: 'CMB_CampaignSummary', type: 'page', meta: {title: "CMB Summary", sidebar: false}, props: true}
  ],
  pages: {
    ComponentName: []
  }
}

export async function initialize()
{
  try {
    const data = await getConfiguration();
    return mergeObjects(data, defaults)
  }
  catch (error) {
        return {}
  }
}
